var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('resource-form',{attrs:{"id":_vm.id,"type":"video","plural":"videos"},model:{value:(_vm.video),callback:function ($$v) {_vm.video=$$v},expression:"video"}})}
var staticRenderFns = []

export { render, staticRenderFns }